// Generated by purs version 0.13.8
"use strict";
var defaultEncoding = {
    tagKey: "tag",
    valuesKey: "values",
    unwrapSingleArguments: false
};
module.exports = {
    defaultEncoding: defaultEncoding
};
